import { useQuery } from '@apollo/client';
import {
  AdminViewerDocument,
  ViewerDocument,
} from '@sandtech-hub-monorepo/ehub-client';
import { useCognito } from '@sandtech-hub-monorepo/ui-auth-kit';

export const useGetMaybeViewer = () => {
  const { currentUser, loading: authLoading } = useCognito();

  const { data, loading: apiLoading } = useQuery(ViewerDocument, {
    fetchPolicy: 'cache-first',
    skip: !currentUser,
    onCompleted: (data) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      window?.pendo?.initialize({
        visitor: {
          id_ehub: data.viewer.sandId,
          id: data.viewer.primaryEmail,
        },
      });
    },
  });

  if (!currentUser) {
    return { viewer: undefined };
  }

  return {
    viewer: data?.viewer,
    loading: authLoading || apiLoading,
  };
};

export const useGetMaybeAdminViewer = () => {
  const { currentUser, loading: authLoading } = useCognito();

  const { data, loading: apiLoading } = useQuery(AdminViewerDocument, {
    fetchPolicy: 'cache-first',
    skip: !currentUser,
  });

  if (!currentUser) {
    return { viewer: undefined };
  }

  return {
    viewer: data?.staffViewer,
    loading: authLoading || apiLoading,
  };
};
